import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

const itemStyle = css`
  border-radius: var(--border-r-seed);
  color: var(--base-text-secondary);
  display: flex;
  font: var(--body-xs-medium);
  padding: var(--layout-seed) var(--layout-soybean);
  text-decoration: none;
`;

export const TabLink = styled(NavLink)`
  ${itemStyle}
  &:hover {
    background-color: var(--control-bg-decorative-hover);
    color: var(--control-text-hover);
  }

  &:focus-visible {
    border-radius: var(--border-r-seed);
    outline: var(--border-b-stamp) solid var(--control-border-focus-ring);
  }

  &.active {
    background-color: var(--control-bg-light-selected);
    color: var(--control-text-decorative-selected);
  }
`;

export const BlockedTabLink = styled.div`
  ${itemStyle}
  color: var(--control-text-disabled);
`;
